'use strict';

const TOAST_TYPES = {
  error: 'error',
  info: 'info',
  remove: 'remove',
  success: 'success',
  warning: 'warning',
};

module.exports = TOAST_TYPES;




// WEBPACK FOOTER //
// ./src/js/core-components/toast-messages/TOAST_TYPES.js